const th = {
    RoleManagement: "การจัดการบทบาท",
    SuperAdminSubtitle:
      "ในฐานะผู้ดูแลระบบระดับสูง คุณสามารถแก้ไขบทบาทของผู้ใช้แต่ละคนได้",
    TotalRecord: "ระเบียนทั้งหมด",
    NoSuperAdminAccess: "คุณไม่มีสิทธิ์ผู้ดูแลระบบระดับสูงเพื่อเข้าถึงหน้านี้",
    GoogleEmail: "อีเมล Google",
    UserName: "ชื่อผู้ใช้",
    UserRole: "บทบาทผู้ใช้",
    PhoneNumber: "หมายเลขโทรศัพท์",
    Actions: "การทำงาน",
    AskMeExample: "ถามฉันได้ เช่น",
    GiveMeInhouseClientsList: "ให้ฉันดูรายชื่อของลูกค้าที่พักในศูนย์",
    WhatIsNextBirthday: "วันเกิดถัดไปคือวันไหน",
    SummarizeLatestNotes: "สรุปบันทึกล่าสุดให้ฉันดู",
    WhereCanISeeInhouseClientsList:
      "ฉันสามารถดูรายชื่อของลูกค้าที่พักในศูนย์ได้ที่ไหน",
    WelcomeToRehappApp: "ยินดีต้อนรับสู่แอป Rehapp",
    LatestSupportTickets: "ตั๋วสนับสนุนล่าสุด",
    NoTicketsFound: "ไม่พบตั๋ว",
    Reset: "รีเซ็ต",
    PleaseSendTicket: "กรุณาส่งตั๋วเกี่ยวกับปัญหาที่คุณมี",
    SupportTickets: "ตั๋วสนับสนุน",
    DashboardHelp: "เข้าถึงแดชบอร์ดเพื่อดูภาพรวมกิจกรรมและสถิติที่สำคัญ",
    ClientsHelp:
      "จัดการลูกค้าทั้งหมดตามประเภท (อยู่ในบ้าน ดูแลภายหลัง กำลังจะมา เป็นต้น)",
    NotesHelp: "ดูและกรองบันทึกตามประเภทเพื่อติดตามการโต้ตอบกับลูกค้า",
    RoomAvailabilityHelp: "ดูจำนวนห้องว่างต่อวัน",
    RoomBookingHelp: "ดูรายละเอียดการจองรายวันพร้อมชื่อและรายละเอียดของลูกค้า",
    CRMHelp:
      "นำเสนอบอร์ดคัมบังพร้อมการ์ดลูกค้าตามสถานะ ช่วยให้จัดการความคืบหน้าในการคัดเลือกลูกค้า",
    MetricsHelp: "แสดงเมตริกและสถิติต่างๆ",
    ExportDataHelp: "ส่งออกข้อมูลลูกค้าในกรณีที่ลูกค้าต้องการรับข้อมูลของตน",
    DocumentsHelp: "จัดเก็บเอกสารที่ผู้ใช้คนอื่นสามารถเข้าถึงได้",
    SupportHelp: "ส่งตั๋วไปยังฝ่ายสนับสนุนเพื่อขอความช่วยเหลือ",
    InHouseClientsInfo:
      "ที่นี่คุณสามารถดูจำนวนลูกค้าทั้งหมดที่อยู่ในสถานที่ปัจจุบัน คลิกที่วิดเจ็ตนี้เพื่อดูรายละเอียดเพิ่มเติมเกี่ยวกับลูกค้าเหล่านี้",
    NextClientDepartureInfo:
      "วิดเจ็ตนี้แสดงลูกค้าคนถัดไปที่มีกำหนดการออกเดินทางรวมถึงชื่อและวันที่ออกที่วางแผนไว้ คลิกเพื่อดูข้อมูลเพิ่มเติมเกี่ยวกับลูกค้าคนนี้",
    NextIncomingClientInfo:
      "วิดเจ็ตนี้แสดงลูกค้าคนถัดไปที่จะเข้ามาพร้อมกับวันที่คาดว่าจะมาถึง คลิกเพื่อเรียนรู้เพิ่มเติมเกี่ยวกับลูกค้าคนนี้",
    UpcomingClientsInfo:
      "วิดเจ็ตนี้แสดงจำนวนลูกค้าทั้งหมดที่มีกำหนดจะมาถึงในไม่ช้า คลิกเพื่อดูรายละเอียดเพิ่มเติมเกี่ยวกับลูกค้าเหล่านี้",

    MandatoryFormsSection:
      "นี่คือส่วน 'แบบฟอร์มที่จำเป็น' ซึ่งคุณสามารถเพิ่ม ดู และจัดการแบบฟอร์มที่จำเป็นทั้งหมดที่ต้องใช้สำหรับการเข้ารับและกระบวนการรักษาของลูกค้า โปรดตรวจสอบให้แน่ใจว่าเอกสารที่จำเป็นทั้งหมดถูกกรอกและเป็นปัจจุบันเพื่อให้ปฏิบัติตามกฎระเบียบและให้การดูแลอย่างครอบคลุม",
    AuthorizationSection:
      "นี่คือส่วน 'การอนุญาตให้เปิดเผยข้อมูลลับ' ที่นี่คุณมีความสามารถในการจัดการและเพิ่มแบบฟอร์มอนุญาตใหม่ที่อนุญาตให้เปิดเผยข้อมูลลับของลูกค้าแก่ฝ่ายที่ได้รับอนุญาต การจัดการเอกสารเหล่านี้อย่างระมัดระวังเป็นสิ่งสำคัญเพื่อรักษาความเป็นส่วนตัวและปฏิบัติตามข้อกำหนดทางกฎหมาย",
    SearchBar:
      "นี่คือแถบค้นหาที่คุณสามารถค้นหาลูกค้าโดยการป้อนชื่อหรือตัวข้อมูลที่เกี่ยวข้องอื่นๆ ช่วยให้คุณค้นหาและเข้าถึงรายละเอียดของลูกค้าได้อย่างรวดเร็ว ทำให้การทำงานของคุณมีประสิทธิภาพมากขึ้น",
    AIServicePrompt:
      "ลองใช้บริการ AI ของเราที่นี่! ฟีเจอร์นี้ใช้ประโยชน์จากปัญญาประดิษฐ์ที่ทันสมัยเพื่อช่วยคุณในงานต่างๆ ทำให้ประสบการณ์ของคุณราบรื่นและเป็นมิตรมากขึ้น คลิกที่นี่เพื่อสำรวจว่า AI สามารถเพิ่มประสิทธิภาพการทำงานของคุณและเสนอทางออกที่ชาญฉลาดได้อย่างไร",
    ProfileWidget:
      "นี่คือวิดเจ็ตโปรไฟล์ของคุณที่คุณสามารถจัดการการตั้งค่าบัญชี ดูข้อมูลโปรไฟล์และเข้าถึงความชอบส่วนบุคคลได้ มันให้วิธีที่รวดเร็วในการปรับแต่งประสบการณ์ของคุณและติดตามข้อมูลบัญชีของคุณ",

    PreviousWeek: "สัปดาห์ที่แล้ว",
    NextWeek: "สัปดาห์หน้า",
    AgeNonEditable: "อายุ (แก้ไขไม่ได้)",
    PageConcerned: "หน้าที่เกี่ยวข้อง",
    AddNewTicket: "เพิ่มตั๋วใหม่",
    WriteDescription: "เขียนคำอธิบายปัญหาของคุณด้านล่าง",
    UploadScreenshots: "อัปโหลดภาพหน้าจอของปัญหาด้านล่างหากคุณมี",
    TicketName: "ชื่อตั๋ว",
    Priority: "ลำดับความสำคัญ",
    TicketType: "ประเภทตั๋ว",
    Medium: "กลาง",
    Low: "ต่ำ",
    High: "สูง",
    DateOfBirth: "วันเกิด",
    DateOfBirthRequired: "จำเป็นต้องระบุวันเกิด",
    Create: "สร้าง",
    AddNewLead: "เพิ่ม Lead ใหม่",
    UpdateLead: "อัปเดต Lead",
    PhoneNumberRequired: "จำเป็นต้องระบุหมายเลขโทรศัพท์",
    FailedToCreateOrUpdateLead:
      "ไม่สามารถสร้าง/อัปเดต Lead ได้ โปรดลองอีกครั้ง",
    LeadUpdatedSuccessfully: "อัปเดต Lead สำเร็จแล้ว!",
    LeadCreatedSuccessfully: "สร้าง Lead สำเร็จแล้ว!",
    Dashboard: "หน้าแรก",
    Clients: "ลูกค้า",
    Client: "ลูกค้า",
    ClientsC: "ลูกค้า",
    ClientC: "ลูกค้า",
    Notes: "บันทึก",
    MyProfile: "โปรไฟล์ของฉัน",
    RoomAvailability: "ห้องว่าง",
    RoomBooking: "การจองห้องพัก",
    Metrics: "ตัวชี้วัด",
    ExportData: "ส่งออกข้อมูล",
    Documents: "เอกสาร",
    SearchClient: "ค้นหาลูกค้า...",
    Settings: "การตั้งค่า",
    SignOut: "ออกจากระบบ",
    NextDeparture: "การออกเดินทางครั้งต่อไป",
    NextIncoming: "การเข้ามาถัดไป",
    Incoming: "ขาเข้า",
    NoDischarges: "ไม่มีการปลดปล่อย",
    NoUpcomingClient: "ไม่มีลูกค้ารายใหม่",
    LastClientNotes: "บันทึกลูกค้าล่าสุด",
    Date: "วันที่",
    DateC: "วันที่",
    Content: "เนื้อหา",
    ContentC: "เนื้อหา",
    Type: "ประเภท",
    Edit: "แก้ไข",
    Delete: "ลบ",
    ShowMoreNotes: "แสดงบันทึกเพิ่มเติม",
    ShowLessNotes: "แสดงบันทึกน้อยลง",
    ClickHereForHelp: "คลิกที่นี่เพื่อรับความช่วยเหลือบนหน้าจอ",
    AddClient: "เพิ่มลูกค้า",
    AddTheClient: "เพิ่มลูกค้า",
    AddNewClient: "เพิ่มลูกค้าใหม่",
    FirstName: "ชื่อจริง",
    LastName: "นามสกุล",
    LastName2: "นามสกุล",
    Nickname: "ชื่อเล่น",
    Gender: "เพศ",
    Email: "อีเมล",
    PhoneNumber: "เบอร์โทรศัพท์",
    Country: "ประเทศ",
    PrimaryAddiction: "การเสพติดหลัก",
    PrimaryAddictionT: "การเสพติดหลัก",
    DurationOfStay: "ระยะเวลาที่เข้าพัก",
    ETA: "เวลามาถึง",
    ClientSource: "แหล่งลูกค้า",
    ProjectedResidentialDischargeDate: "วันที่คาดว่าจะออกจากที่พักอาศัย",
    ProjectedProgramCompletionDate: "วันที่คาดว่าจะจบโปรแกรม",
    ProjectedResidentialDischargeDateRequired:
      "วันที่คาดว่าจะออกจากที่พักอาศัยจำเป็นต้องระบุ",
    ProjectedProgramCompletionDateRequired:
      "วันที่คาดว่าจะจบโปรแกรมจำเป็นต้องระบุ",
    PersonalInfos: "ข้อมูลส่วนตัว",
    AddictionInfos: "ข้อมูลการเสพติด",
    DischargeInfos: "ข้อมูลการจำหน่าย",
    FirstNameRequired: "ต้องระบุชื่อจริง",
    LastNameRequired: "ต้องระบุนามสกุล",
    NicknameRequired: "ต้องระบุชื่อเล่น",
    EmailRequired: "ต้องระบุอีเมล",
    ETARequired: "ต้องระบุ ETA",
    Back: "ย้อนกลับ",
    Next: "ถัดไป",
    Finish: "เสร็จสิ้น",
    DemoTestNoClient: "ทดสอบสาธิต: ไม่มีลูกค้าเพิ่ม :)",
    ClientName: "ชื่อลูกค้า",
    TypeQuickSessionNote: "พิมพ์โน๊ตเซสชันด่วนที่นี่",
    NoteContent: "เนื้อหาของโน๊ต",
    EffectiveDateTime: "วันที่และเวลาที่มีผลของโน๊ต",
    EffectiveDate: "วันที่และเวลาที่มีผล",
    NoteContent: "เนื้อหาของโน๊ต",
    TypeNoteHere: "พิมพ์โน๊ตของคุณที่นี่",
    StartShift: "เริ่มกะทำงาน",
    TypeNoteHere: "พิมพ์โน๊ตของคุณที่นี่",
    EndShift: "จบกะทำงาน",
    SelectStaff: "เลือกพนักงาน",
    EffectiveDateOnly: "วันที่มีผล",
    FamilyNoteRelationship: "ความสัมพันธ์ในโน๊ตครอบครัว",
    GroupTopic: "หัวข้อกลุ่ม",
    GroupDateStartTime: "วันที่และเวลาเริ่มต้นของกลุ่ม",
    TypeOfGroup: "ประเภทของกลุ่ม",
    GroupNote: "โน๊ตกลุ่ม",
    TypeGroupNoteHere: "พิมพ์โน๊ตกลุ่มที่นี่",
    ClientsNotInAttendance: "ลูกค้าที่ไม่ได้เข้าร่วม",
    TypeNamesHere:
      "พิมพ์ชื่อที่นี่ (ชื่อจริง / หรือชื่อที่ต้องการและอักษรย่อของนามสกุล) และเหตุผลว่าทำไมลูกค้าไม่อยู่ในกลุ่ม, ถ้าทราบ...",
    ImmigrationAppointment: "การนัดหมายตรวจคนเข้าเมือง / วีซ่า",
    DischargesFlights: "การปล่อยตัว / การจัดการเที่ยวบิน",
    NewClients: "ลูกค้าใหม่",
    PsychiatristAppointments: "การนัดหมายกับจิตแพทย์",
    HospitalAppointments: "การนัดหมายโรงพยาบาล",
    Outings: "กิจกรรมภายนอก",
    ZoomSessionAssistance: "การช่วยเหลือเซสชัน Zoom",
    StaffToday: "พนักงานวันนี้",
    Overnight: "กลางคืน",
    NumberOfClients: "จำนวนลูกค้า",
    Swot: "Swot",
    GeneralAnnouncement: "ประกาศทั่วไป / การสนทนา",
    EditFamilyNote: "แก้ไขโน๊ตครอบครัว",
    EditQuickNote: "แก้ไขโน๊ตด่วน",
    EditAftercareNote: "แก้ไขโน๊ตการดูแลต่อเนื่อง",
    EditGroupNote: "แก้ไขโน๊ตกลุ่ม",
    EditMedicalNote: "แก้ไขโน๊ตทางการแพทย์",
    EditSupportStaffNote: "แก้ไขโน๊ตพนักงานสนับสนุน",
    EditTherapyNote: "แก้ไขโน๊ตบำบัด",
    EditHandoverNote: "แก้ไขโน๊ตการส่งต่อ",
    Cancel: "ยกเลิก",
    Save: "บันทึก",
    TypeGroupNoteHere: "พิมพ์บันทึกกลุ่มของคุณที่นี่",
    TypeMedicalNoteHere: "พิมพ์บันทึกทางการแพทย์ของคุณที่นี่",
    ImportFile: "นำเข้าไฟล์",
    MaximumFileSize: "ขนาดไฟล์สูงสุด : 50 MB",
    SelectedFile: "ไฟล์ที่เลือก",
    FileAlreadyUploaded: "ไฟล์ถูกอัปโหลดแล้ว",
    AreYouSureToDeleteFile: "คุณแน่ใจหรือว่าต้องการลบไฟล์นี้?",
    Confirm: "ยืนยัน",
    ConfirmDeletion: "ยืนยันการลบ",
    TotalRecord: "บันทึกรวม",
    Filters: "ตัวกรอง",
    SelectClientType: "เลือกประเภทลูกค้า",
    SelectTherapist: "เลือกนักบำบัด",
    SelectAddiction: "เลือกการเสพติด",
    SelectILS: "เลือก ILS",
    ResetFilters: "รีเซ็ตตัวกรอง",
    ADDICTION: "การเสพติด",
    AKA: "ชื่อเล่น",
    AGE: "อายุ",
    ADMISSION: "การรับเข้า",
    THERAPIST: "นักบำบัด",
    ROOM: "ห้อง #",
    SUPPORT_STAFF: "เจ้าหน้าที่สนับสนุน",
    PleaseSelectBothDates: "โปรดเลือกทั้งวันเริ่มต้นและวันสิ้นสุด",
    SelectRangeDate: "เลือกช่วงวันที่:",
    SeeMore: "ดูเพิ่มเติม",
    TO: "ถึง",
    RoomsAvailablePerDay: "ห้องว่าง / วัน",
    DistributionPerDay: "การแจกจ่าย / วัน",
    RoomAvailability: "ความพร้อมของห้องพัก",
    RoomBooking: "การจองห้องพัก",
    FullscreenMode: "โหมดเต็มจอ",
    NoCredentials:
      "--คุณไม่มีข้อมูลประจำตัว Super-admin หรือ Admin เพื่อเข้าถึงหน้านี้--",
    ExitFullscreen: "ออกจากโหมดเต็มจอ",
    TodaysDate: "วันที่วันนี้",
    IncomingDischarges: "การปลดปล่อยที่จะเข้ามา",
    NightsMo: "คืน Mo.",
    LOSToDate: "L.O.S ถึงปัจจุบัน",
    LOSIntended: "L.O.S.(ที่ตั้งใจไว้)",
    TotalNightsBooked: "คืนที่จองทั้งหมด",
    TotalIncomingNights: "คืนที่กำลังจะมาถึงทั้งหมด",
    TotalPotentialNights: "คืนที่มีศักยภาพทั้งหมด",
    TotalProjectedNights: "คืนที่คาดการณ์ทั้งหมด",
    January: "มกราคม",
    February: "กุมภาพันธ์",
    March: "มีนาคม",
    April: "เมษายน",
    May: "พฤษภาคม",
    June: "มิถุนายน",
    July: "กรกฎาคม",
    August: "สิงหาคม",
    September: "กันยายน",
    October: "ตุลาคม",
    November: "พฤศจิกายน",
    December: "ธันวาคม",
    BedOccRate: "อัตราการครองเตียง",
    InHouseClients: "# ผู้ป่วยใน",
    AvTreatmentDur: "ระยะเวลาการรักษาเฉลี่ย",
    ClientsByAddictionTypeInhouse: "ผู้ป่วยในตามประเภทการเสพติด",
    ClientsByAddictionTypeAllClients: "ผู้ป่วยทั้งหมดตามประเภทการเสพติด",
    ClientsByTherapistInhouse: "ผู้ป่วยในตามนักบำบัด",
    Day: "วัน",
    Status: "สถานะ",
    Nationality: "สัญชาติ",
    SecondaryAddiction: "การเสพติดทุติยภูมิ",
    LengthOfStay: "ระยะเวลาการเข้าพัก",
    LengthOfStay: "ระยะเวลาพัก",
    InActiveRecovery: "อยู่ในการฟื้นฟูหรือไม่?",
    GoogleReviewDone: "รีวิว Google เสร็จหรือยัง?",
    ExportData: "ส่งออกข้อมูล",
    ExportData2: "ส่งออกข้อมูล",
    Documents: "เอกสาร",
    UPLOADING: "กำลังอัปโหลด...",
    UPLOAD: "อัปโหลด",
    NoFileSelected: "ไม่ได้เลือกไฟล์ กรุณาเลือกไฟล์และตั้งชื่อไฟล์",
    ChooseFile: "เลือกไฟล์",
    FileRequirements:
      "(ครั้งละหนึ่งไฟล์เท่านั้น รองรับเฉพาะ PDF, JPG หรือ PNG ขนาดไม่เกิน 5MB)",
    UploadDocument: "อัปโหลดไฟล์เอกสาร",
    NoFilesFound: "ไม่พบไฟล์",
    NoDeletePermissions: "คุณไม่มีสิทธิ์ลบไฟล์นี้",
    OneFileLimit: "คุณสามารถอัปโหลดไฟล์ได้เพียงไฟล์เดียวเท่านั้น",
    FileDeleted: "ลบไฟล์สำเร็จ!",
    ErrorDeletingFile: "เกิดข้อผิดพลาดในการลบไฟล์",
    FileSizeExceedsLimit: "ขนาดไฟล์เกินขีดจำกัด:",
    FilesUploaded: "อัปโหลดไฟล์สำเร็จ!",
    ErrorUpdatingClient: "เกิดข้อผิดพลาดในการอัปเดตลูกค้า:",
    NoFilesSelected: "ไม่มีไฟล์ที่เลือกสำหรับการอัปโหลด",
    FileName: "ชื่อไฟล์",
    AreYouSureYouWantToDeleteTheFile: "คุณแน่ใจหรือไม่ว่าต้องการลบไฟล์นี้",
    permanently: "อย่างถาวร?",
    TryOurAI: "ลอง A.I. ของเรา",
    ArtificialIntelligence: "ปัญญาประดิษฐ์",
    Photo: "รูปถ่าย",
    Email: "อีเมล",
    PhoneNumber: "เบอร์โทร",
    Role: "บทบาท",
    Edit: "แก้ไข",
    ChooseFile: "เลือกไฟล์",
    Profile: "โปรไฟล์",
    ProfileUpdatedSuccessfully: "อัปเดตโปรไฟล์สำเร็จ",
    ErrorUpdatingProfile: "ข้อผิดพลาดในการอัปเดตโปรไฟล์:",
    User: "ผู้ใช้",
    SuccessfullyLoggedOut: "ออกจากระบบสำเร็จ",
    LogOut: "ออกจากระบบ",
    Name: "ชื่อ",
    AskMeAnything: "ถามฉันอะไรก็ได้",
    NoPrimaryAddictionRecorded: "ไม่มีการบันทึกการเสพติดหลัก",
    PromptInstruction:
      "ในช่องคำสั่งด้านล่าง ให้ถามคำถามใดๆ เกี่ยวกับ EHR นี้และคำถามเกี่ยวกับลูกค้า คุณสามารถถามในภาษาใดก็ได้",
    AnonymizedRequests:
      "ทุกคำขอจะถูกทำให้ไม่ระบุตัวตน (ชื่อจริงของลูกค้าจะไม่ถูกส่งไปยังแบบจำลอง AI)",
    AskAbout: "ถามเกี่ยวกับ :",
    HowToAddClient: "ฉันจะเพิ่มลูกค้าได้อย่างไร?",
    GenerateReport: "ฉันสามารถสร้างรายงานความก้าวหน้าของลูกค้าได้ไหม?",
    JanesProgress: "ความก้าวหน้าของเจนเป็นอย่างไร?",
    JohnsRecentNotes: "บันทึกล่าสุดของจอห์นคืออะไร?",
    SummaryOfNotes: "ให้สรุปบันทึกของสัปดาห์ที่แล้วหน่อย",
    NoteAddedSuccess: "เพิ่มบันทึกสำเร็จ",
    SelectedClient: "ลูกค้าที่เลือก",
    NoClientSelected: "--ยังไม่ได้เลือกลูกค้า--",
    SelectAClient: "เลือกลูกค้า",
    TypeNamesAndReason:
      "พิมพ์ชื่อที่นี่ (ชื่อจริง / หรือชื่อที่ต้องการและชื่อย่อของนามสกุล) และเหตุผลว่าทำไมลูกค้าไม่อยู่ในกลุ่ม หากทราบ...",
    IfOtherDescribe: "ถ้าอื่น ๆ กรุณาอธิบาย",
    StartOfShift: "เริ่มกะ",
    EndOfShift: "สิ้นสุดกะ",
    SelectStaff: "เลือกพนักงาน",
    Add: "เพิ่ม",
    EditEndOfShiftNote: "แก้ไขบันทึกสิ้นสุดกะ",
    WelcomeToRehabAppDemo: "ยินดีต้อนรับสู่ Rehab-App (สาธิต)",
    ContinueWithGoogle: "ดำเนินการต่อด้วย Google",
    LogInWithGoogle: "เข้าสู่ระบบด้วย Google",
    InternetConnectionWorking: "การเชื่อมต่ออินเทอร์เน็ตของคุณทำงานได้",
    InternetConnectionNotWorking:
      "การเชื่อมต่ออินเทอร์เน็ตของคุณไม่ทำงาน กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ตของคุณ",
    SuccessfullyLoggedInWithGoogle:
      "เข้าสู่ระบบเรียบร้อยแล้วโดยใช้บัญชี Google ของคุณ",
    MustLogInWithMiraclesAsiaEmail:
      "คุณต้องเข้าสู่ระบบด้วยที่อยู่อีเมลที่ลงท้ายด้วย @miraclesasia.com เพื่อเข้าถึงแอปพลิเคชันนี้",
    FailedToLogInWithGoogle: "ไม่สามารถเข้าสู่ระบบด้วยบัญชี Google ของคุณ",
    NoRoleFoundForUser: "ไม่พบบทบาทสำหรับผู้ใช้รายนี้ใน Firestore",
    MustLogInWithGmailOrGsuite:
      "คุณต้องเข้าสู่ระบบด้วยที่อยู่อีเมล Gmail หรือ G Suite เพื่อเข้าถึงแอปพลิเคชันนี้",
    ClientNameRequired: "จำเป็นต้องมีชื่อคลายแอน",
    ContentRequired: "จำเป็นต้องมีเนื้อหา",
    EffectiveDateRequired: "จำเป็นต้องมีวันที่ที่มีผล",
    ImmigrationAppointmentRequired: "จำเป็นต้องมีการนัดหมายตรวจคนเข้าเมือง",
    DischargesFlightsRequired: "จำเป็นต้องมีการปล่อยตัว / เที่ยวบิน",
    NewClientsRequired: "จำเป็นต้องมีลูกค้าใหม่",
    PsychiatristAppointmentsRequired: "จำเป็นต้องมีการนัดหมายกับจิตแพทย์",
    HospitalAppointmentsRequired: "จำเป็นต้องมีการนัดหมายที่โรงพยาบาล",
    OutingsRequired: "จำเป็นต้องมีการออกนอกสถานที่",
    ZoomSessionAssistanceRequired: "จำเป็นต้องมีการสนับสนุนเซสชัน Zoom",
    StaffTodayRequired: "จำเป็นต้องมีพนักงานในวันนี้",
    OvernightRequired: "จำเป็นต้องค้างคืน",
    NumberOfClientsRequired: "จำเป็นต้องมีจำนวนลูกค้า",
    SwotRequired: "จำเป็นต้องมี SWOT",
    GeneralAnnouncementRequired: "จำเป็นต้องมีการประกาศทั่วไป",
    GroupTopicRequired: "จำเป็นต้องมีหัวข้อกลุ่ม",
    StartTimeRequired: "จำเป็นต้องมีเวลาที่เริ่มต้น",
    GroupTypeRequired: "จำเป็นต้องมีประเภทกลุ่ม",
    NotInAttendanceRequired: "จำเป็นต้องมีผู้ที่ไม่เข้าร่วม",
    StartOfShiftRequired: "จำเป็นต้องมีการเริ่มต้นกะ",
    EndOfShiftRequired: "จำเป็นต้องมีการสิ้นสุดกะ",
    StaffRequired: "จำเป็นต้องมีพนักงาน",
    PleaseFillAllRequiredFields: "กรุณากรอกข้อมูลที่จำเป็นทั้งหมด",
    PersonalInformation: "ข้อมูลส่วนบุคคล",
    FirstName: "ชื่อ",
    LastName: "นามสกุล",
    Nickname: "ชื่อเล่น",
    Email: "อีเมล",
    PhoneNumber: "หมายเลขโทรศัพท์",
    Birthday: "วันเกิด",
    AgeNotEditable: "อายุ (แก้ไขไม่ได้)",
    MaritalStatus: "สถานภาพสมรส",
    LivingWith: "อาศัยอยู่กับ",
    IfOtherDescribe: "หากอื่น ๆ โปรดระบุ",
    Gender: "เพศ",
    IfOtherGenderDescribe: "หากเพศอื่น ๆ โปรดระบุ",
    SexualOrientation: "รสนิยมทางเพศ",
    PhysicalAddressOfResidence: "ที่อยู่ที่พักอาศัย",
    City: "เมือง",
    ProvinceState: "จังหวัด / รัฐ",
    Country: "ประเทศ",
    Nationality: "สัญชาติ",
    ClientSource: "แหล่งที่มาของลูกค้า",
    PassportNumber: "หมายเลขหนังสือเดินทาง",
    VisaExpirationDate: "วันหมดอายุของวีซ่า",
    TreatmentInformation: "ข้อมูลการรักษา",
    ClientStatus: "สถานะลูกค้า",
    RoomNumber: "หมายเลขห้อง",
    AssignedTherapist: "นักบำบัดที่ได้รับมอบหมาย",
    AssignedSupportStaff: "พนักงานสนับสนุนที่ได้รับมอบหมาย",
    AdmissionAndDischarge: "การรับเข้า & การปล่อยตัว",
    ActualAdmissionDate: "วันที่เข้ารับการรักษาจริง",
    ActualDischargeDate: "วันที่ปล่อยตัวจริง",
    ProjectedDischargeDate: "วันที่ปล่อยตัวที่คาดการณ์ไว้",
    ProjAftercareCompletionDate:
      "วันที่เสร็จสิ้นการดูแลหลังการรักษาที่คาดการณ์ไว้",
    PassportPictures: "รูปถ่ายหนังสือเดินทาง",
    ImportFile: "นำเข้าไฟล์",
    MaximumFileSize: "ขนาดไฟล์สูงสุด: 100MB",
    UploadingFile: "กำลังอัปโหลดไฟล์...",
    UploadedFiles: "ไฟล์ที่อัปโหลดแล้ว",
    EmergencyContact: "ผู้ติดต่อฉุกเฉิน",
    EmergencyContactFirstName: "ชื่อจริงของผู้ติดต่อฉุกเฉิน",
    EmergencyContactLastName: "นามสกุลของผู้ติดต่อฉุกเฉิน",
    Relationship: "ความสัมพันธ์",
    IfOtherDescribe: "ถ้าอื่น ๆ โปรดอธิบาย",
    ContactPhoneNumber: "หมายเลขโทรศัพท์ของผู้ติดต่อ",
    ContactEmail: "อีเมลของผู้ติดต่อ",
    PhysicalAddressOfResidence: "ที่อยู่ที่พักอาศัย",
    City: "เมือง",
    Nationality: "สัญชาติ",
    StateProvince: "รัฐ / จังหวัด",
    Country: "ประเทศ",
    PersonPayingForTreatment: "บุคคลที่ชำระเงินสำหรับการรักษา",
    PhoneNumberOfPersonPaying: "หมายเลขโทรศัพท์ของบุคคลที่ชำระเงิน",
    SavingModifications: "กำลังบันทึกการแก้ไข...",
    ClickToSave: "คลิกเพื่อบันทึก",
    SaveModifications: "บันทึกการแก้ไข",
    UploadLimitExceeded: "คุณสามารถอัปโหลดได้สูงสุด 3 ไฟล์เท่านั้น",
    FileSizeExceedsLimit: "ขนาดไฟล์เกินขีดจำกัด:",
    FilesSuccessfullyUploaded: "ไฟล์อัปโหลดสำเร็จ!",
    FileSuccessfullyDeleted: "ไฟล์ถูกลบสำเร็จ!",
    ErrorDeletingFile: "เกิดข้อผิดพลาดในการลบไฟล์",
    GeneralInformation: "ข้อมูลทั่วไป",
    ActivityLogs: "บันทึกกิจกรรม",
    Help: "ช่วยเหลือ",
    Close: "ปิด",
    NoRecentActivity: "ไม่มีความเคลื่อนไหวล่าสุด",
    Language: "ภาษา",
    Admin: "ผู้ดูแลระบบ",
    NoClientIdentifier: "ไม่มีตัวระบุลูกค้า",
    NoTherapistAssignedYet: "ยังไม่มีการกำหนดนักบำบัด",
    AssignedTherapist: "นักบำบัดที่ได้รับมอบหมาย:",
    IntendedDurationOfStay: "ระยะเวลาที่ตั้งใจจะพัก",
    AdmissionDate: "วันที่เข้ารับการรักษา",
    MandatoryForms: "แบบฟอร์มบังคับ",
    AreYouSureToDeleteNote: "คุณแน่ใจหรือไม่ว่าต้องการลบโน้ตนี้?",
    AreYouSureToDeleteFile: "คุณแน่ใจหรือไม่ว่าต้องการลบไฟล์นี้?",
    FileSuccessfullyDeleted: "ลบไฟล์สำเร็จแล้ว!",
    ErrorDeletingFile: "เกิดข้อผิดพลาดในการลบไฟล์",
    NoteSuccessfullyDeleted: "ลบโน้ตสำเร็จแล้ว!",
    ErrorDeletingNote: "เกิดข้อผิดพลาดในการลบโน้ต:",
    Deleting: "กำลังลบ...",
    Updating: "กำลังอัปเดต...",
    NoRecentActivity: "ไม่มีการทำกิจกรรมล่าสุด",
    LastModification: "การแก้ไขล่าสุด",
    ClientAddedBy: "ลูกค้าเพิ่มโดย",
    EstimateDateOfArrival: "วันที่คาดว่าจะมาถึง",
    IntendedDurationOfStay: "ระยะเวลาที่ตั้งใจจะพัก",
    PassportStatus: "สถานะพาสปอร์ต",
    PassportCopy: "สำเนาพาสปอร์ต",
    PrevClientIdentifier: "รหัสประจำตัวลูกค้าก่อนหน้านี้",
    FlightDetails: "รายละเอียดเที่ยวบิน",
    Itinerary: "แผนการเดินทาง",
    VIPTransfer: "การโอน VIP",
    PaymentDetails: "รายละเอียดการชำระเงิน",
    MaritalStatus: "สถานภาพการสมรส",
    CurrentPartnerIfNotMarried: "คู่สมรสในปัจจุบันหากไม่ได้แต่งงาน?",
    ChildrensOrDependents: "บุตรหรือผู้อยู่ในอุปการะ",
    CurrentLivingArrangements: "การจัดการที่อยู่อาศัยปัจจุบัน",
    DietaryRequirements: "ข้อกำหนดทางโภชนาการ",
    FundingSource: "แหล่งเงินทุน",
    PrimAddSubstOrProcAbove:
      "การเสพติดหลัก (ทั้งการใช้สารเสพติดหรือกระบวนการที่กล่าวข้างต้น)",
    IfOtherSelectedDescribe: "หากเลือกอื่นๆ ให้ระบุ",
    SecondaryAddiction: "การเสพติดรอง",
    IfOtherSelectedDescribeSecondary: "หากเลือกอื่นๆ ให้ระบุ",
    SubstanceAddictions: "การเสพติดสารเสพติด",
    DoCCurrentUsageLevels:
      "ระดับการใช้งานในปัจจุบัน (ความถี่, ปริมาณ) และวิธี (การสูบบุหรี่, การฉีด, การดม, การรับประทานทางปาก)",
    AnyCurrentWithdrawalSymptoms: "อาการถอนสารเสพติดในปัจจุบัน",
    ProcessAddictions: "การเสพติดกระบวนการ",
    TypeProcessAddiction:
      "ประเภท, เช่น การพนัน, เซ็กส์, สื่อลามก, อาหาร, การเล่นเกม; และความถี่ในการมีส่วนร่วมในพฤติกรรมการเสพติดกระบวนการ",
    AddictionTreatmentHistory: "ประวัติการรักษาการเสพติด",
    MainUnwantedConsequences: "ผลกระทบที่ไม่พึงประสงค์หลักของการเสพติด",
    HowLongHasAddictionBeenAProblem:
      "การใช้ยาเสพติด/ดื่มสุรา/กระบวนการเสพติดเป็นปัญหานานเท่าไหร่?",
    WhatLedYouToSeekTreatmentNow:
      "อะไรเป็นแรงจูงใจให้คุณต้องการเข้ารับการรักษาในขณะนี้?",
    TreatmentGoals: "เป้าหมายการรักษา",
    BarriersForRehab: "อุปสรรคในการบำบัด",
    MotivationForTreatment: "แรงจูงใจในการรักษา",
    SavingModifications: "กำลังบันทึกการเปลี่ยนแปลง...",
    ClickToSave: "คลิกเพื่อบันทึก",
    SaveModifications: "บันทึกการเปลี่ยนแปลง",
    Addictions: "การเสพติด",
    PreAdmissionAssessment: "การประเมินก่อนเข้ารับการรักษา",
    AdmissionForms: "แบบฟอร์มการรับเข้า",
    AuthorizationReleaseConfidentialInfo: "การอนุญาตให้เปิดเผยข้อมูลลับ",
    AddRCIForm: "เพิ่มแบบฟอร์ม R.C.I.",
    UnableToAddMandatoryForms:
      "ไม่สามารถเพิ่มแบบฟอร์มบังคับได้หากยังไม่ได้รับการรับรองลูกค้า",
    UnableToAddROIForm:
      "ไม่สามารถเพิ่มแบบฟอร์ม R.O.I. ได้หากยังไม่ได้รับการรับรองลูกค้า",
    CompanyIndividualName: "ชื่อบริษัท / บุคคล",
    Filled: "กรอกแล้ว",
    Revoked: "เพิกถอน",
    Actions: "การดำเนินการ",
    Relationship: "ความสัมพันธ์",
    SelectedClient: "ลูกค้าที่เลือก:",
    ConfidentialityPolicyForm: "แบบฟอร์มนโยบายความลับ",
    PleaseSignBelow: "กรุณาลงชื่อด้านล่างและคลิกยืนยันเมื่อเสร็จสิ้น",
    SignatureNotValidated: "ลายเซ็นไม่ได้รับการยืนยัน",
    SignatureValidated: "ลายเซ็นได้รับการยืนยัน!",
    Clear: "ล้าง",
    Validate: "ยืนยัน",
    Saving: "กำลังบันทึก...",
    GeneralLiabilityReleaseForm: "แบบฟอร์มการสละความรับผิดชอบทั่วไป",
    GeneralLiabilityFormSubmitted:
      "แบบฟอร์มการสละความรับผิดชอบทั่วไปส่งเรียบร้อยแล้ว!",
    ErrorAddingDocument: "เกิดข้อผิดพลาดในการเพิ่มเอกสาร",
    InformedConsentForm: "แบบฟอร์มยินยอมที่ได้รับการแจ้ง",
    InformedConsentFormSubmitted:
      "แบบฟอร์มยินยอมที่ได้รับการแจ้งส่งเรียบร้อยแล้ว!",
    ConfidentialityPolicyFormSubmitted:
      "แบบฟอร์มนโยบายความลับส่งเรียบร้อยแล้ว!",
    PleaseAgreeToTerms: "โปรดตกลงตามเงื่อนไขทั้งหมดก่อนที่จะส่ง",
    Print: "พิมพ์",
    Intervention: "การแทรกแซง",
    AddTreatment: "เพิ่มการรักษา",
    Adding: "กำลังเพิ่ม...",
    Objective: "วัตถุประสงค์",
    AddObjective: "เพิ่มวัตถุประสงค์",
    ObjectivesAssociatedInterventions:
      "วัตถุประสงค์และการแทรกแซงที่เกี่ยวข้องขณะรับการรักษาที่ศูนย์บำบัด:",
    PresentingIssues: "ปัญหาที่นำเสนอ:",
    LongTermGoals: "เป้าหมายระยะยาว (หลังการรักษาที่ศูนย์บำบัด):",
    FailedToSaveTreatmentPlan:
      "ไม่สามารถบันทึกแผนการรักษาได้ กรุณาลองอีกครั้ง.",
    TreatmentPlanSuccessfullyAdded: "แผนการรักษาเพิ่มเรียบร้อยแล้ว!",
    PleaseFillRequiredFields: "กรุณากรอกข้อมูลในช่องที่จำเป็นทั้งหมด.",
    ObjectiveIntervention: "วัตถุประสงค์ / การแทรกแซง",
    TreatmentPlan: "แผนการรักษา",
    DischargeSummary: "สรุปการออกจากการรักษา",
    DischargeDate: "วันที่ออกจากการรักษา",
    DischargeType: "ประเภทการออกจากการรักษา",
    DischargeTo: "ออกจากการรักษาไปยัง",
    DateOfAdmission: "วันที่เข้ารับการรักษา",
    TotalLengthOfStay: "ระยะเวลาการรักษาทั้งหมด",
    MedicationPrescribedUponDischarge: "ยาที่สั่งจ่ายเมื่อออกจากการรักษา",
    IdentifiedIssuesUponAdmission: "ปัญหาที่ระบุได้เมื่อเข้ารับการรักษา",
    EmergingIssuesDuringTreatment: "ปัญหาที่เกิดขึ้นระหว่างการรักษา",
    OverallLevelOfEngagement: "ระดับการมีส่วนร่วมในโปรแกรมโดยรวม",
    Resistance: "ความต้านทาน",
    HighlyEngaged: "มีส่วนร่วมสูง",
    Progress: "ความก้าวหน้า",
    FamilyInvolvement: "การมีส่วนร่วมของครอบครัว / คนสำคัญ",
    RoadblocksConcerns: "อุปสรรค/ข้อกังวล",
    ClientPrognosis: "พยากรณ์โรคของผู้ป่วย",
    RecommendedDischargePlan: "แผนการออกจากการรักษาที่แนะนำ",
    StaffMemberName: "ชื่อสมาชิกทีมงาน",
    Submit: "ส่ง",
    LeaveAgainstClinicalAdvice: "ออกจากโรงพยาบาลโดยขัดคำแนะนำทางการแพทย์ (ACA)",
    EmergencyDischarge: "การออกฉุกเฉิน",
    TreatmentPlanFor: "แผนการรักษาสำหรับ:",
    EditTreatmentPlan: "แก้ไขแผนการรักษา",
    Review: "รีวิว",
    TypeReviewHere: "พิมพ์รีวิวที่นี่",
    AddReviews: "เพิ่มรีวิว",
    UpdateReviews: "อัปเดตรีวิว",
    Updating: "กำลังอัปเดต...",
    ObjectiveReviewsUpdated: "อัปเดตการตรวจสอบวัตถุประสงค์สำเร็จแล้ว!",
    FailedToUpdateObjectiveReviews:
      "การอัปเดตการตรวจสอบวัตถุประสงค์ล้มเหลว กรุณาลองใหม่อีกครั้ง.",
    TreatmentPlanUpdated: "อัปเดตแผนการรักษาสำเร็จแล้ว!",
    FailedToSaveTreatmentPlan:
      "การบันทึกแผนการรักษาล้มเหลว กรุณาลองใหม่อีกครั้ง.",
    SelectNoteType: "เลือกประเภทบันทึก",
    StartDate: "วันที่เริ่มต้น",
    EndDate: "วันที่สิ้นสุด",
    AddNote: "เพิ่มบันทึก",
    GeneralDocuments: "เอกสารทั่วไป",
    TherapistsDocuments: "เอกสารของนักบำบัด",
    CRM: "CRM",
    Medication: "ยา",
    Invoicing: "การออกใบแจ้งหนี้",
    Support: "สนับสนุน",
    AddAlert: "เพิ่มการแจ้งเตือน",
    EditAlert: "แก้ไขการแจ้งเตือน",
    PleaseSelectTypeAndContent:
      "โปรดเลือกประเภทและป้อนเนื้อหาสำหรับการแจ้งเตือน",
    ConfirmDeleteAlert: "คุณแน่ใจหรือไม่ว่าต้องการลบการแจ้งเตือนนี้?",
    ShowMore: "แสดงเพิ่มเติม",
    ShowLess: "แสดงน้อยลง",
    Alerts: "การแจ้งเตือน",
    ClinicalInformations: "ข้อมูลทางคลินิก",
    AddTreatmentPlan: "เพิ่มแผนการรักษา",
    NoTreatmentPlanAdded: "ไม่ได้เพิ่มแผนการรักษา โปรดเพิ่มแผนการรักษา",
    Added: "เพิ่ม",
    Reviewed: "ตรวจสอบแล้ว",
    DischargeForms: "แบบฟอร์มการจำหน่าย",
    PrimaryAddictionColon: "การเสพติดหลัก:",
    NoAdmissionDateYet: "ยังไม่มีการบันทึกวันที่รับเข้า",
    NoDurationOfStayYet: "ยังไม่มีการบันทึกระยะเวลาการเข้าพัก",
    YearsOld: "ปี",
    ClientProfile: "โปรไฟล์ลูกค้า",
  };

export default th;
